<script setup lang="ts">
import { watchEffect } from 'vue'

const { showNotification, error, customError, customErrorParams, customSuccessMessage, errorReference }
  = storeToRefs(useProjectStore())
const intervalRef = ref()
const { t } = useI18n()
function closeNotification() {
  error.value = null
  customError.value = null
  errorReference.value = null
  customSuccessMessage.value = null
  showNotification.value = false
}

function getMessage() {
  return (
    t(customError.value ?? '', customErrorParams?.value ?? {})
    || (error.value && t('something_went_wrong'))
    || t(customSuccessMessage.value ?? '')
    || t('successfully_saved')
  )
}

watchEffect(() => {
  if (showNotification.value === true) {
    intervalRef.value = setInterval(() => {
      closeNotification()
    }, 5000)
  }
  else if (intervalRef.value) {
    clearInterval(intervalRef.value)
    intervalRef.value = null
  }
})
</script>

<template>
  <transition
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
    enter-active-class="transition duration-500"
    leave-active-class="transition duration-1000">
    <div
      v-if="showNotification"
      class="absolute bottom-28 right-1/2 z-[100] flex w-1/4 min-w-60 translate-x-1/2 items-center justify-start gap-4 self-stretch rounded bg-primary-navyblue-800 p-4 text-white shadow">
      <div
        class="secu-body-bold flex shrink grow basis-0 items-center space-x-spacing-sm">
        <SvgoError v-if="error || customError" class="size-6 shrink-0" />
        <SvgoSuccess v-else class="size-6 shrink-0" />
        <div>
          <p>
            {{ getMessage() }}
          </p>
          <!-- The API's error ID, so a report to support leads to one log entry. -->
          <p
            v-if="errorReference && (error || customError)"
            class="secu-body-micro select-all opacity-80"
            data-testid="error-reference">
            {{ t('error_reference', { id: errorReference }) }}
          </p>
        </div>
      </div>
      <div />
      <button class="m-0 h-fit" @click="closeNotification()">
        <SvgoClose class="relative size-5" />
      </button>
    </div>
  </transition>
</template>
